import React, { useEffect, useRef } from 'react';
import styles from './index.module.styl';
export const EmptyLineChart = () => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  // colors
  const SOLID_COLOR = "rgba(79, 68, 224, 0.1)";
  const DASHED_COLOR = "rgba(79, 68, 224, 0.1)";
  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas === null) {
      return;
    }
    const ctx = canvas.getContext("2d");
    if (ctx === null) {
      return;
    }
    const width = canvas.width;
    const height = canvas.height;
    const midY = height / 2;
    const solidPoints = [21, 15, 21, 30, 35, 20, 22, 28, 21, 10, 5, 18, 20, 18, 21, 5, 30, 25, 10, 15];
    const dashedPoints = [31, 21, 31, 35, 25, 23, 31, 20, 11, 3, 7, 4, 10, 8, 12, 22, 15, 14, 3, 9];

    // Clear the canvas
    ctx.clearRect(0, 0, width, height);

    // draw the SOLID line:
    ctx.setLineDash([]);
    ctx.lineWidth = 1.5;
    ctx.strokeStyle = SOLID_COLOR;
    ctx.beginPath();
    ctx.moveTo(0, midY + (solidPoints[0] - 20));
    solidPoints.forEach((pt, i) => {
      const x = i / (solidPoints.length - 1) * width;
      const y = midY + (pt - 20);
      ctx.lineTo(x, y);
    });
    ctx.stroke();

    // draw the DOTTED line:
    ctx.setLineDash([2, 2]);
    ctx.lineWidth = 1.5;
    ctx.strokeStyle = DASHED_COLOR;
    ctx.beginPath();
    ctx.moveTo(0, midY + (dashedPoints[0] - 20));
    dashedPoints.forEach((pt, i) => {
      const x = i / (dashedPoints.length - 1) * width;
      const y = midY + (pt - 20);
      ctx.lineTo(x, y);
    });
    ctx.stroke();

    // reset dash
    ctx.setLineDash([]);
  }, []);
  return <div className={styles.emptyLineChart} data-sentry-component="EmptyLineChart" data-sentry-source-file="index.tsx">
      <canvas ref={canvasRef} width='225' height='40' />
    </div>;
};